import { useQuery } from '@tanstack/react-query';

import { getOfferingTransaction } from '@arrived/api_v2';
import { OfferingTransaction, OfferingTransactionId } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { tradeQueryKeyFn } from './trades.keys';

export function useTradeQuery(tradeId?: OfferingTransactionId, options?: UseQueryOptions<OfferingTransaction>) {
  return useQuery(tradeQueryKeyFn(tradeId), () => getOfferingTransaction(tradeId!), {
    ...options,
    enabled: (options?.enabled ?? true) && tradeId != null,
  });
}
